import { inject, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';

import { AppError, ErrorsInterceptor } from '@hglobal/common';

import { AUTHORIZATION_ERROR_CODE, AuthService, EXPIRED_TOKEN_ERROR_CODE } from '@pp/core/auth-store';
import { LostConnectionDialog } from '@pp/core/components';

/**
 * App Errors interceptor
 */
@Injectable()
export class AppErrorsInterceptor extends ErrorsInterceptor {
  readonly #router = inject(Router);
  readonly #injector = inject(Injector);
  readonly #lostConnectionDialog = inject(LostConnectionDialog);

  readonly #logOutCodesCollection = new Map([
    [AUTHORIZATION_ERROR_CODE, 'Authorization error code from backend'],
    [EXPIRED_TOKEN_ERROR_CODE, 'Expired token error code from backend'],
  ]);

  readonly #nonNavigableErrorCodes = new Set([403, 400, 401, 0, 524]);

  override beforeThrowing(error: AppError): AppError {
    if (this.#logOutCodesCollection.has(error?.originalError?.error?.error_code)) {
      const auth = this.#injector.get(AuthService);
      auth.logout();
    }

    if (!this.#nonNavigableErrorCodes.has(error.originalError.status)) {
      this.#router.navigate(['500']);
    } else if (error.originalError.status === 0 || error.originalError.status === 524) {
      this.#lostConnectionDialog.open();
    }

    return error;
  }
}
